import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class CorrectPercentDisplay extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.bg = ABCyaPhaser.Images.addImage(0, 0, 'ScoreDisplay', this).setOrigin(0, 0);
    this.txt = this.scene.add.bitmapText(this.bg.getBounds().width / 2 - 3, 80, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('buttons.correct'), 26).setCenterAlign()
      .setTintFill('0xFFFFFF')
      .setOrigin(.5, 0);

    this.txtScore = this.scene.add.bitmapText(0, 0, 'asapReg', '100%', 34).setCenterAlign()
      .setTintFill('0xFFFFFF');

    this.txtScore.x = this.bg.getBounds().width / 2 - this.txtScore.width / 2;
    this.txtScore.y = this.bg.getBounds().height / 2 - this.txtScore.height / 2 - 25;
    this.add(this.txt);
    this.add(this.txtScore);
  }

  updateScore(score) {
    this.txtScore.text = `${score}%`;
    this.txtScore.x = this.bg.getBounds().width / 2 - this.txtScore.width / 2;
    this.txtScore.y = this.bg.getBounds().height / 2 - this.txtScore.height / 2 - 25;
  };
}